import React from 'react'
import '../assets/css/navbutton.css'

function Navbutton() {
  const showMenu = () => {
    const menuHamb = document.getElementsByClassName('hamburger')
    const menuNav = document.getElementById('nav')
    const mItem = document.getElementsByClassName('nav-item-deco-b')

    if (menuNav.style.left === '0%') {
      menuHamb[0].classList.remove('is-active')
      menuNav.style.transitionDelay = '0s'
      menuNav.style.left = '100%'
    } else {
      menuNav.style.transitionDelay = '0s'
      menuNav.style.left = '0%'
      menuHamb[0].classList.add('is-active')
      mItem[0].style.left = '0%'
      mItem[1].style.left = '0%'
      mItem[2].style.left = '0%'
      mItem[3].style.left = '0%'
    }
  }

  return (
    <button
      className='hamburger hamburger--spring'
      onClick={showMenu}
      type='button'
    >
      <span className='hamburger-box'>
        <span className='hamburger-inner'></span>
      </span>
      <span className='nav-btn-label'>MENU</span>
    </button>
  )
}

export default Navbutton
